<template>
  <!-- 运单轨迹 -->
  <el-dialog
    title="轨迹"
    :visible.sync="isShow"
    class="dialog-lg dialog-map"
    @close="closeM"
    @closed="mapClose"
    @open="mapOpen"
  >
    <map-line
      :linePath="linePoint"
      :mapType="mapTypes"
      :positionStatus="positionStatus"
      v-if="showMap"
    ></map-line>
    <el-row class="guiji-row">
      <el-row
        v-for="(item, index) in guijiList"
        :key="index"
        class="guiji-detail"
      >
        <el-row v-if="item.address != ''">位置：{{ item.address }}</el-row>
        <el-row>时间：{{ item.time }}</el-row>
        <el-row v-if="item.speed != null">车速：{{ item.speed }}km/h</el-row>
      </el-row>
    </el-row>
    <el-row class="guiji-nvo" v-if="mapTypes == 'CAR_TYPE'">
      <span>车牌号：{{ nvo }}</span>
      <span style="margin-left: 20px">司机姓名：{{ driver_name }}</span>
      <span style="margin-left: 20px">司机手机号 ：{{ accompany_mobile }}</span>
    </el-row>
    <el-row class="guiji-nvo" v-if="mapTypes == 'BOAT_TYPE'">
      <span>船舶号：{{ nvo }}</span>
      <span style="margin-left: 20px">船长姓名：{{ driver_name }}</span>
      <span style="margin-left: 20px">船长手机号 ：{{ accompany_mobile }}</span>
    </el-row>
  </el-dialog>
</template>

<script>
import { isSuccess, model, getImageModel } from "@/assets/js/utils";
export default {
  data() {
    return {
      isShow: false,
      mapTypes: "",
      status: "",
      showMap: false,
      guijiList: [],
      points: [],
      nvo: "",
      accompany_mobile: "",
      driver_name: "",
    };
  },
  created() {},
  computed: {
    linePoint: function () {
      return this.points;
    },
    mapType: function () {
      return this.mapTypes;
    },
    positionStatus: function () {
      return this.status;
    },
  },
  methods: {
    //打开弹窗
    show(pid, type, status) {
      this.pid = pid;
      this.points = [];
      this.guijiList = [];
      this.nvo = "";
      this.driver_name = "";
      this.accompany_mobile = "";
      this.mapTypes = type;
      this.status = status;
      console.log(this.status);
      api("waybill.historical.route", { id: pid, type: this.mapTypes }).then(
        (res) => {
          let data = isSuccess(res);
          if (data.length > 0) {
            this.isShow = true;
            this.showMap = true;
            res.data.forEach((item) => {
              this.points.push({
                lng: item.lng,
                lat: item.lat,
              });
              this.guijiList.push({
                address: item.address,
                time: item.create_time,
                speed: item.speed,
              });
            });
            this.nvo = data[0].nvo;
            this.driver_name = data[0].driver_name;
            this.accompany_mobile = data[0].accompany_mobile;
          } else {
            alert("暂无轨迹");
          }
        }
      );
    },
    //解决地图缩放移位
    mapOpen: function () {
      this.top = this.getScrollTop();
      if (this.top) {
        this.setScrollTop(0);
      }
    },
    mapClose: function () {
      this.setScrollTop(this.top);
      this.top = 0;
    },
    getScrollTop: function () {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    setScrollTop: function (top) {
      if (!isNaN(top)) {
        if (
          document.documentElement &&
          document.documentElement.scrollTop !== undefined
        ) {
          document.documentElement.scrollTop = top;
        } else if (document.body) {
          document.body.scrollTop = top;
        }
      }
    },
    closeM() {
      // this.showMap = false
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/sass/mixin";
.file-bd-more {
  height: 140px;
  width: 160px;
  overflow: hidden;
}
.file-bt-more {
  padding: 10px;
  text-align: center;
  height: 140px;
  line-height: 120px;
  border: 1px dashed $borderColor;
}
.del-btn {
  font-size: 14px;
  color: #cc0816;
  float: right;
}
.yu-btn {
  font-size: 14px;
  color: #cc0816;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/waybill-line-map.vue